/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: '${{amount}}',
            labelAddedToCart: 'was added to your cart.',
            labelCartIsEmpty: 'Your Cart is currently empty!',
            labelQuantity: 'Quantity:',
            labelRemove: 'Remove',
            hiddenItemTag: 'hidden-product',
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;

        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    init() {

        this.fetchCart();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */

        if (this.addToCart) { 
            this.addToCart.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    let form = item.parentNode;
                    while (form && 'form' !== form.tagName.toLowerCase()) {
                      	
                        form = form.parentNode;
                    }
                    const formID = form.getAttribute('id');
                    this.addItemToCart(formID);
                });
            });
        }

        this.cartTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });

        this.cartOverlay.addEventListener('click', () => {
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', () => {
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                });
            });
        }

        const _this = this
        document.addEventListener('rebuy.add', function(event){ 
            // console.log(event)
            _this.fetchAndOpenCart()
        });
    }

    fetchCart(callback) {
        window.fetch('/cart?view=ajax', {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cart) => { eval(cart); this.fetchHandler(window.cart, callback)})
            .catch((error) => {
          		console.error(error);
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    addItemToCart(formID) {
        const form = document.querySelector(`#${formID}`);
        const formData = serialize(form, {hash: true});
        window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((product) => this.addItemToCartHandler(product))
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    removeItem(line) {
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

	addSubscriptionItem(itemData) { 
        window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                items: [
                    {
                        id: itemData.subscription_variant_id,
                        quantity: 1,
                        properties: {
                            'shipping_interval_frequency': itemData.subscription_properties.frequency[0],
                            'shipping_interval_unit_type': itemData.subscription_properties.interval
                        }
                    }
                ]
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then(() => this.fetchCart())
        .catch((error) => {
            this.ajaxRequestFail();
            throw new Error(error);
        });
    }

    upgradeItemToSubscription(itemData, line) {
        // remove first
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then(() => this.addSubscriptionItem(itemData))
        .catch((error) => {
            this.ajaxRequestFail();
            throw new Error(error);
        });
    }

    redirectToReChargeCheckout() { 
        if ( !window.cart.has_subscription_products ) { 
            var checkout_url = this.cartCheckout.getAttribute('href');
            window.location.href = checkout_url;

            return;
        }

        var checkout_url = this.buildCheckoutUrl(window.cart);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/update.js');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function() {
            if (xhr.status === 200) {
                window.console.log('done', JSON.parse(xhr.responseText));
            } else if (xhr.status !== 200) {
                window.console.log('fail', JSON.parse(xhr.responseText));
            }

            var form = document.createElement('form');
            form.setAttribute('method', 'post');
            form.setAttribute('action', checkout_url);
            form.setAttribute('id', 'rc_form');
            form.style.display = 'none';

            if (window.cart.customer) { 
                Object.keys(window.cart.customer).forEach(function(key) {
                    var input = document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('name', key);
                    input.setAttribute('value', typeof(window.cart.customer[key]) === 'object' ? JSON.stringify(window.cart.customer[key]) : window.cart.customer[key]);
                    form.appendChild(input);
                });
            }

            document.body.appendChild(form);
            form.submit();
        };
        xhr.send(JSON.stringify(window.cart));
    }

    changeItemQuantity(line, quantity) {
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    cartItemCount(cart) {
        // this.cartCount.innerHTML = cart.item_count;
        this.cartCount.forEach((item) => {
            item.innerHTML = cart.item_count;
        });
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            if (this.isDrawerMode) {
                this.openCartDrawer();
            } else {
                this.openMiniCart();
            }
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);
        if (this.isDrawerMode) {
            if (cart.item_count === 0) {
                this.renderBlankCartDrawer();
                this.cartDrawerFooter.classList.add('is-invisible');
            } else {
                this.renderDrawerCart(cart);
                this.cartDrawerFooter.classList.remove('is-invisible');
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
            }
        } else if (cart.item_count === 0) {
            this.renderBlankMiniCart();
            this.cartMiniCartFooter.classList.add('is-invisible');
        } else {
            this.renderMiniCart(cart);
            this.cartMiniCartFooter.classList.remove('is-invisible');
            if ((typeof callback) === 'function') {
                callback(cart);
            }
        }
    }

    addItemToCartHandler(product) {
      var $ptwobject = window.jQuery;
      if($ptwobject("#ptw-gift-needed").is(":checked")) {
        console.log('test 1');
      var ptwVariantId = $ptwobject("#ptw-variant-id").val();
      var ptw_gift_note = $ptwobject("#ptw-text-message").val();
      var ptwProdName = $ptwobject("#ptw-productname").val();
      var ptwProductProps = {
          "Gift Note": ptw_gift_note,
          "Product Name": ptwProdName,
        };
        var ptwProductParams = {
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: [
            {
              quantity: 1,
              id: ptwVariantId,
              properties: ptwProductProps,
            },
          ],
        },
        dataType: "json",
        cache: false,
        async: false
      };
         $ptwobject.ajax(ptwProductParams).done(function (data) {
      console.log("Gift Wrap Added 1");

    });
        
      }
        
        return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }

    ajaxRequestFail() {
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ? 
              `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>` : 
              `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
    }

    renderDrawerCart(cart) {
    
      // free shipping bar
      this.clearCartDrawer();
      this.renderShippingMotivator(cart);
      
      let cartOriginTotal = 0;
      let maxDiscount     = 5;
       
       cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
         
         	if ( item.is_subscription && item.onetime_variant_price > item.final_price ) { 
                cartOriginTotal += item.quantity * item.onetime_variant_price;
            } else { 
                cartOriginTotal += item.quantity * item.final_price;
            }

            if ( item.is_subscription && item.subscription_properties.discount > maxDiscount ) { 
                maxDiscount = item.subscription_properties.discount;
            }

            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                  <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                  <div class="go-cart-item__info">
                    <div class="go-cart-title-price">
                      ${item.product_tags.includes(this.hiddenItemTag) ? 
                      `<p class="go-cart-item__title body1">${item.product_title}</p>` : 
                      `<a href="${item.url}" class="go-cart-item__title body1">${item.product_title}</a>`}
                      <div class="go-cart-item__price body1">${(item.is_subscription && item.onetime_variant_price > item.final_price)? `<s> ${formatMoney(item.onetime_variant_price * item.quantity, this.moneyFormat)}</s>` : ``} ${formatMoney(item.line_price, this.moneyFormat)} ${(item.is_subscription && item.onetime_variant_price > item.final_price)? `<span>Save ${item.subscription_properties.discount}%</span>` : ``}</div>
                    </div>
                    <div class="go-cart-item__variant body1">${itemVariant}</div>
                    <div class="go-cart-qty-remove body1">
                      <div class="go-cart-item__quantity qty-wrap">
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus qty-minus"><i class="fa-solid fa-minus"></i></span>`}
                        <input class="go-cart-item__quantity-number js-go-cart-quantity qty-input" type="number" value="${item.quantity}" disabled>
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus qty-plus"><i class="fa-solid fa-plus"></i></span>`}
                      </div>
                      <a class="go-cart-item__remove ${this.removeFromCartNoDot}">Remove</a>
                    </div>
					${(item.is_subscription === false && item.has_subscription !== null && item.has_subscription === true) ?
                        `<div class="go-cart-item__upgrade-subscription js-go-cart-item__upgrade-subscription">Upgrade To Subscribe & Save ${item.subscription_properties.discount}%</div>` : ``
                    }
                  </div>
                </div>
              </div>`;
            this.cartDrawerContent.innerHTML += cartSingleProduct;
        });
        this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode);
                const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });

		const upgradeSubscription = document.querySelectorAll('.js-go-cart-item__upgrade-subscription');
        if (upgradeSubscription) { 
            upgradeSubscription.forEach((item) => {
              item.addEventListener('click', () => {
              const line = parseInt(item.parentNode.parentNode.parentNode.getAttribute('data-line'));

              let cartItem = window.cart.items[line - 1];

              // remove item from the side-cart
              GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode);
              // this.removeItem(line);

              // add subscription product
              this.upgradeItemToSubscription(cartItem, line);
            });
          });
        }

    }
    
    renderMiniCart(cart) {
        this.clearMiniCart();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        <div class="go-cart-title-price">
                          ${item.product_tags.includes(this.hiddenItemTag) ? 
                          `<p class="go-cart-item__title body1">${item.product_title}</p>` : 
                          `<a href="${item.url}" class="go-cart-item__title body1">${item.product_title}</a>`}
                          <div class="go-cart-item__price body1">${formatMoney(item.line_price, this.moneyFormat)}</div>
                        </div>
                        <div class="go-cart-item__variant">${itemVariant}</div>
                        <div class="go-cart-qty-remove body1">
                          <div class="go-cart-item__quantity qty-wrap">
                            ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus qty-minus"><i class="fa-solid fa-minus"></i></span>`}
                            <input class="go-cart-item__quantity-number js-go-cart-quantity qty-input" type="number" value="${item.quantity}" disabled>
                            ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus qty-plus"><i class="fa-solid fa-plus"></i></span>`}
                          </div>
                          <a class="go-cart-item__remove ${this.removeFromCartNoDot}">Remove</a>
                        </div>
                    </div>
                </div>
                
              </div>`;
            this.cartMiniCartContent.innerHTML += cartSingleProduct;
        });
        this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }
    
    renderShippingMotivator(cart) {
      var motivator = document.querySelector("#js-go-cart-motivator");
      if (motivator) {
        motivator.removeAttribute("hidden");
        
        var cart_has_bundles = false;
        cart.items.forEach(item=>{
          if (item.product_tags.includes("bundle")) {
            cart_has_bundles=true;
          }
        });
        
        
		const baseFreeShippingValue = parseFloat(motivator.getAttribute("data-total-trigger"));
		let cartTotalPrice = (cart.total_price/ 100 ).toFixed(2);
        
        
        if ((cartTotalPrice >= baseFreeShippingValue) || cart_has_bundles ) {
          motivator.querySelector(".shipping-progress-header").innerHTML = "Congratulations! You're eligible for <strong>Free Ground Shipping</strong>";
          motivator.querySelector(".shipping-progress-percentage").style.setProperty("--tool-tip-percent", "100%"); 
        } else {
		  let remainFreeShippingValue = ( baseFreeShippingValue - cartTotalPrice ) * 100;
          remainFreeShippingValue = (remainFreeShippingValue/100).toFixed(2);
          const progressbarWidth = ( ( cartTotalPrice  / baseFreeShippingValue ) * 100 ).toFixed(2);
          motivator.querySelector(".shipping-progress-header").innerHTML = `$${remainFreeShippingValue} away from <strong>Free Ground Shipping</strong>`;
          motivator.querySelector(".shipping-progress-percentage").style.setProperty("--tool-tip-percent", `${progressbarWidth}%`);
        }
      }
    }

    renderBlankCartDrawer() {
        this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
        this.clearCartDrawer();
        this.cartDrawerContent.innerHTML += `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
    }

    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
        this.clearMiniCart();
        this.cartMiniCartContent.innerHTML += `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
    }

    reloadAjaxContent() {
      this.fetchAndOpenCart();
    }

    clearCartDrawer() {
      	var motivator;
      try {
        motivator = this.cartDrawerContent.querySelector("#js-go-cart-motivator").cloneNode(true);
      } catch (e) {
      }
        this.cartDrawerContent.innerHTML = '';
      	if (motivator) {
          motivator.setAttribute("hidden","");
          this.cartDrawerContent.appendChild(motivator);
        }
        
    }

    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = '';
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
    }

    openMiniCart() {
        this.cartMiniCart.classList.add('is-open');
    }

    closeMiniCart() {
        this.cartMiniCart.classList.remove('is-open');
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }

}

//export default GoCart;

